import { JetCardPricingProps } from '@/types/jetCardPricing.types';
import styles from './jetPricing.module.scss';
import Image from 'next/image';

const JetCard10HoursPricing = ({ card }: JetCardPricingProps) => {
  return (
    <section className="container">
      <div className={styles.cardWrapper}>
        {card.map((item) => (
          <div key={item.id} className={styles.card}>
            <div
              className={styles.cardTitle}
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
            <div className={styles.cardImgContainer}>
              <Image
                src={item.img}
                alt={item.title}
                fill
                className={styles.cardImg}
              />
              <div
                className={styles.plainNameOverlay}
                dangerouslySetInnerHTML={{ __html: item.plainName }}
              />
            </div>
            <div className={styles.cardPriceWrapper}>
              <div className={styles.cardPriceTitle}>
                Starting at <span>{item.pricePerHour}</span> per hour
              </div>
              <div className={styles.cardPriceTitle}>
                <span>{item.price}</span> per 10 hours
              </div>
              <div className={styles.cardPriceNote}>
                All-inclusive pricing. No fuel surcharges or hidden fees.
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JetCard10HoursPricing;
